import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Vacancy() {
    const navigate = useNavigate();
    const [vacancies, setVacancies] = useState([]);
    const [filteredVacancies, setFilteredVacancies] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedVacancy, setExpandedVacancy] = useState(null); // Track the expanded vacancy

    const handleApply = () => {
        navigate("/cv");
    };

    useEffect(() => {
        const fetchVacancies = async () => {
            try {
                const response = await fetch("https://sheetdb.io/api/v1/qb852u808nuvw");
                if (!response.ok) {
                    throw new Error("Failed to fetch vacancies");
                }

                const data = await response.json();
                if (Array.isArray(data)) {
                    setVacancies(data);
                    setFilteredVacancies(data);
                } else {
                    setVacancies([]);
                    setFilteredVacancies([]);
                }
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };
        fetchVacancies();
    }, []);

    const handleSearchChange = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        const filtered = vacancies.filter((vacancy) =>
            vacancy["Job Title"].toLowerCase().includes(query)
        );
        setFilteredVacancies(filtered);
    };

    // Toggle the expanded state for a specific vacancy
    const handleToggleDetails = (jobTitle) => {
        setExpandedVacancy(expandedVacancy === jobTitle ? null : jobTitle);
    };

    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Current Vacancies</h1>
                </div>
            </div>
            <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
                <Container>
                    {/* Search Input */}
                    <Row className="mb-4 px-3">
                        <Col md={4}>
                            <Form.Control
                                type="text"
                                placeholder="Search by Job Title..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                        </Col>
                    </Row>

                    {/* Loading or Error */}
                    {loading ? (
                        <Row className="mb-3">
                            <Col>
                                <p>Loading...</p>
                            </Col>
                        </Row>
                    ) : error ? (
                        <Row className="mb-3">
                            <Col>
                                <p>{error}</p>
                            </Col>
                        </Row>
                    ) : filteredVacancies.length > 0 ? (
                        filteredVacancies.map((vacancy, index) => (
                            <Row
                                key={index}
                                className="job-row mb-3"
                                style={{
                                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8f9fa",
                                    border: "1px solid #e3e3e3",
                                    borderRadius: "8px",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <Col sm={12} lg={3}>
                                    <h5
                                        style={{ marginBottom: "5px", cursor: "pointer", color: '#007bff' }}
                                        onClick={() => handleToggleDetails(vacancy["Job Title"])}
                                    >
                                        {vacancy["Job Title"]}
                                        {expandedVacancy === vacancy["Job Title"] ? (
                                            <i className="fa fa-chevron-up" style={{ marginLeft: '10px', verticalAlign: 'center' }} />
                                        ) : (
                                            <i className="fa fa-chevron-down" style={{ marginLeft: '10px', verticalAlign: 'center' }} />
                                        )}
                                    </h5>
                                    <p style={{ marginBottom: "0", color: "#6c757d" }}>
                                        {vacancy["Location"]}
                                    </p>
                                </Col>
                                <Col sm={12} lg={4}>
                                    <p><b>Job Id: </b>{vacancy["JobId"]}</p>
                                    <p><b>Sector: </b>{vacancy["Sector"]}</p>
                                </Col>
                                <Col sm={12} lg={3} className="text-center emp-type">
                                    <p><b>Published Date : </b>{vacancy["Published Date"]}</p>
                                    <p><b>Apply Before&nbsp;&nbsp;&nbsp; : </b>{vacancy["Application Deadline"]}</p>
                                </Col>

                                <Col sm={12} lg={2} className="text-center emp-type">
                                    <span
                                        className={`badge ${vacancy["Employment Type"] === "Full Time"
                                            ? "bg-success"
                                            : "bg-warning"
                                            } text-light`}
                                    >
                                        {vacancy["Employment Type"]}
                                    </span>
                                </Col>

                                {/* Expanded Details */}
                                {expandedVacancy === vacancy["Job Title"] && (
                                    <>
                                        <Col sm={12} lg={12}>
                                            <div style={{ whiteSpace: 'pre-line' }}>
                                                {vacancy["Job Description"]}
                                            </div>
                                            <p></p>
                                        </Col>
                                        <Col sm={12} lg={6}>
                                            <h5 style={{ marginBottom: "5px" }}>Roles and Responsibilities:</h5>

                                            <div>
                                                {vacancy["Roles and Responsibility"]?.split('\n').map((line, i) => {
                                                    const trimmed = line.trim();

                                                    if (/^.+:$/.test(trimmed)) {
                                                        return (
                                                            <div key={i}>
                                                                <strong>{trimmed}</strong>
                                                            </div>
                                                        );
                                                    } else if (trimmed.startsWith('•')) {
                                                        return (
                                                            <div key={i} style={{ paddingLeft: '20px' }}>
                                                                {trimmed}
                                                            </div>
                                                        );
                                                    } else {
                                                        return (
                                                            <div key={i}>
                                                                {trimmed}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>
                                            {/* <ul style={{ marginBottom: "0", color: "#6c757d", paddingLeft: "20px" }}>
                                                {vacancy["Roles and Responsibility"]?.split("\n").map((role, index) => (
                                                    <li key={index}>{role}</li>
                                                ))}
                                            </ul> */}
                                        </Col>
                                        <Col sm={12} lg={6}>
                                            <h5 style={{ marginBottom: "5px" }}>Key Skills:</h5>
                                            <div>
                                                {vacancy["Skills"]?.split('\n').map((line, i) => {
                                                    const trimmed = line.trim();

                                                    if (/^[a-zA-Z ]+:$/.test(trimmed)) {
                                                        // Bold heading like "Mandatory:"
                                                        return (
                                                            <div key={i}>
                                                                <strong>{trimmed}</strong>
                                                            </div>
                                                        );
                                                    } else if (trimmed.startsWith('•')) {
                                                        // Bullet points
                                                        return (
                                                            <div key={i} style={{ paddingLeft: '20px' }}>
                                                                {trimmed}
                                                            </div>
                                                        );
                                                    } else {
                                                        // Normal text
                                                        return (
                                                            <div key={i}>
                                                                {trimmed}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>

                                            {/* <ul style={{ marginBottom: "0", color: "#6c757d", paddingLeft: "20px" }}>
                                                {vacancy["Skills"]?.split("\n").map((skill, index) => (
                                                    <li key={index}>{skill}</li>
                                                ))}
                                            </ul> */}
                                        </Col>

                                        <Col sm={12} lg={12} className="d-flex justify-content-lg-end justify-content-center align-items-center">
                                            <Button
                                                type="submit"
                                                className="btn form-btns px-5 mt-5"
                                                onClick={handleApply}
                                            >
                                                Apply Now
                                            </Button>
                                        </Col>
                                    </>
                                )}
                            </Row>
                        ))
                    ) : (
                        <Row className="mb-3">
                            <Col>
                                <p>No Vacancies Found</p>
                            </Col>
                        </Row>
                    )}
                </Container>
            </section>
        </>
    );
}
